import { render, staticRenderFns } from "./chatAi.vue?vue&type=template&id=0ae2027a&scoped=true"
import script from "./chatAi.vue?vue&type=script&lang=js"
export * from "./chatAi.vue?vue&type=script&lang=js"
import style0 from "./chatAi.vue?vue&type=style&index=0&id=0ae2027a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae2027a",
  null
  
)

export default component.exports